var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10239_53998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.1921,
    cy: 10.1923,
    r: 8.76923,
    fill: "url(#paint0_linear_10239_53998)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.404 7.09884C13.7346 7.39631 13.9825 7.74337 14.1147 8.15653C14.2469 8.58622 14.2634 8.99938 14.1643 9.42906C14.0651 9.85875 13.8668 10.2223 13.5693 10.5198L10.3797 13.8251C10.264 13.9408 10.1318 13.9904 9.99959 13.9904C9.85085 13.9904 9.71864 13.9408 9.61948 13.8251L6.42988 10.5363C6.11587 10.2223 5.91756 9.85875 5.8184 9.42906C5.71924 8.99938 5.75229 8.58622 5.8845 8.15653C6.01671 7.74337 6.24808 7.39631 6.59514 7.09884C6.89262 6.85094 7.22315 6.68567 7.60325 6.61957C7.96683 6.55346 8.34694 6.58652 8.71052 6.7022C9.07411 6.83441 9.38811 7.03273 9.66906 7.31368L9.99959 7.64421L10.3301 7.31368C10.5945 7.03273 10.9251 6.83441 11.2886 6.7022C11.6522 6.58652 12.0158 6.55346 12.3959 6.61957C12.7595 6.68567 13.1066 6.85094 13.404 7.09884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10239_53998",
    x1: 10.1921,
    y1: 1.9231,
    x2: 10.1921,
    y2: 18.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3223C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10239_53998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.23d484863ab93e2f9fbf84c480fdfef3.svg";
export { ForwardRef as ReactComponent };